/**
 * Education Rewards Routes
 */

export default {
  path: '/education-rewards',
  name: 'education-rewards',
  children: [
    {
      path: '/:id',
      name: 'education-rewards-detail',
      load: () => import(/* webpackChunkName: 'loyalty' */ './detail'),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/routes/client/site/education-rewards/index.js